import { History } from "history";

import { ManualPurchaseRequest } from "../../interfaces";
import {
  ManualPurchaseSubjectSuccessAction,
  ManualPurchaseSubjectErrorAction,
  ResetManualPurchaseSubjectAction,
  ManualPurchaseSubjectAction,
  MANUAL_PURCHASE_SUBJECT,
  MANUAL_PURCHASE_SUBJECT_ERROR,
  MANUAL_PURCHASE_SUBJECT_SUCCESS,
  RESET_MANUAL_PURCHASE_SUBJECT,
} from "./actionTypes";

//#region Manual Purchase
export const manualPurchaseSubject = (
  request: ManualPurchaseRequest,
  history: History
): ManualPurchaseSubjectAction => {
  return {
    type: MANUAL_PURCHASE_SUBJECT,
    payload: { request, history },
  };
};

export const manualPurchaseSubjectSuccess =
  (): ManualPurchaseSubjectSuccessAction => {
    return {
      type: MANUAL_PURCHASE_SUBJECT_SUCCESS,
      payload: null,
    };
  };

export const manualPurchaseSubjectError = (
  error: any
): ManualPurchaseSubjectErrorAction => {
  return {
    type: MANUAL_PURCHASE_SUBJECT_ERROR,
    payload: error,
  };
};

export const resetManualPurchaseSubject =
  (): ResetManualPurchaseSubjectAction => {
    return {
      type: RESET_MANUAL_PURCHASE_SUBJECT,
      payload: null,
    };
  };

//#endregion
